"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeANON = function CategoryCodeANON(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeANON"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M8,3a7.226,7.226,0,0,1-2.059-.3.3.3,0,0,0-.38.219L5,5.31a.3.3,0,0,0,.293.37h5.416A.3.3,0,0,0,11,5.31l-.562-2.385a.3.3,0,0,0-.38-.219A7.226,7.226,0,0,1,8,3Z"
  }), _react.default.createElement("path", {
    d: "M4.441,6.4a6.574,6.574,0,0,0-1.56,1.213.192.192,0,0,0,.134.33h9.968a.192.192,0,0,0,.133-.331A6.707,6.707,0,0,0,11.549,6.4.2.2,0,0,0,11.49,6.4c-.482,0-6.519-.023-7,0A.228.228,0,0,0,4.441,6.4Z"
  }), _react.default.createElement("path", {
    d: "M4.912,8.731a1.309,1.309,0,0,0,1.434,1.276c.79,0,1.433-1.118,1.433-1.118A.409.409,0,0,1,8,8.819a.449.449,0,0,1,.221.07s.643,1.118,1.433,1.118a1.309,1.309,0,0,0,1.434-1.276,1.379,1.379,0,0,0-.033-.3H4.945A1.379,1.379,0,0,0,4.912,8.731Z"
  }), _react.default.createElement("path", {
    d: "M6.862,13.307H3.44a.1.1,0,0,1-.052-.192l1.084-.632a.1.1,0,0,0,.009-.173,10.941,10.941,0,0,0-2.738-1.058.1.1,0,0,1-.04-.176A6.34,6.34,0,0,1,4.845,9.587a.105.105,0,0,1,.116.091,5.331,5.331,0,0,0,1.964,3.446A.1.1,0,0,1,6.862,13.307Z"
  }), _react.default.createElement("path", {
    d: "M9.138,13.307H12.56a.1.1,0,0,0,.052-.192l-1.084-.632a.1.1,0,0,1-.009-.173,10.941,10.941,0,0,1,2.738-1.058.1.1,0,0,0,.04-.176,6.34,6.34,0,0,0-3.142-1.489.105.105,0,0,0-.116.091,5.331,5.331,0,0,1-1.964,3.446A.1.1,0,0,0,9.138,13.307Z"
  }))));
};

var _default = CategoryCodeANON;
exports.default = _default;